import { Injectable } from '@angular/core';
import { HeaderArrayToHttpHeadersConversionService } from './headers/header-array-to-http-headers-conversion.service';
import { AuthorizationHeaderFactoryService } from './headers/authorization-header-factory.service';
import { InstanceIdHeaderFactoryService } from './headers/instance-id-header-factory.service';
import { AcceptHeaderFactoryService } from './headers/accept-header-factory.service';
import { ContentTypeHeaderFactoryService } from './headers/content-type-header-factory.service';
import { ConfigurationService } from '../configuration/configuration.service';
import { environment } from 'src/environments/environment';
import { SuperBatmanHeaderFactoryService } from './headers/super-batman-header-factory.service';

@Injectable({
  providedIn: 'root'
})
export class OpengroundCloudHeadersFactoryService {

  constructor(private headerArrayToHeadersService: HeaderArrayToHttpHeadersConversionService,
    private authHeaderFactoryService: AuthorizationHeaderFactoryService,
    private intanceIdHeaderFactoryService: InstanceIdHeaderFactoryService,
    private acceptHeaderFactoryService: AcceptHeaderFactoryService,
    private contentTypeHeaderFactoryService: ContentTypeHeaderFactoryService,
    private superbatmanHeaderFactoryService: SuperBatmanHeaderFactoryService) {}

  createHeaders(addInstanceIdHeader, addSuperBatmanHeader, addAuthorizationHeader, addFeatureTrackingHeaders) {
    const headerArray = this.createAdditionalHeaderArray(addInstanceIdHeader, addSuperBatmanHeader, addAuthorizationHeader, addFeatureTrackingHeaders);
    const additionalHeaders = this.headerArrayToHeaders(headerArray);
    return {
      ...additionalHeaders
    };
  }

  headerArrayToHeaders(array) {
    return this.headerArrayToHeadersService.run(array);
  }

  createAdditionalHeaderArray(addInstanceIdHeader = true, addSuperBatmanHeader = true, addAuthorizationHeader = false, addFeatureTrackingHeaders = false) {
    const array = [];
    if (addInstanceIdHeader) {
      array.push(this.createInstanceIdHeader());
    }
    if (addAuthorizationHeader) {
      array.push(this.createAuthHeader());
    }

    if (addSuperBatmanHeader) {
      array.push(this.createSuperBatmanHeader());
    }

    if (addFeatureTrackingHeaders) {
      array.push(this.createUserHostHeader());
      array.push(this.createProductVersionHeader());
    }

    return array;
  }

  createSuperBatmanHeader() {
    return this.superbatmanHeaderFactoryService.createHeader();
  }

  createUserHostHeader() {
    const header: any = {};
    header["User-Host-Name"] = "web browser";
    return header;
  }

  createProductVersionHeader() {
    const header: any = {};
    header["Product-Version"] = environment.version;
    return header;
  }

  createAuthHeader() {
    return this.authHeaderFactoryService.createHeader();
  }

  createInstanceIdHeader() {
    return this.intanceIdHeaderFactoryService.createHeader();
  }

  createContentTypeHeader(contentType) {
    return this.contentTypeHeaderFactoryService.createHeader(contentType);
  }

  createAcceptHeader(value) {
    return this.acceptHeaderFactoryService.createHeader(value);
  }
}
